import styled from '@emotion/styled';

export const EstablishmentBlockStyled = styled('div')(() => ({
  height: 560,
}));
